export default "__VITE_ASSET__79e1070d__"